/**
 * Texts for Notifications page
 */
export const notificationsPageText = {
    title: 'Recente in-app meldingen',
    titleMeta: 'Toont recente in-app-meldingen CamAPS FX',
    descriptionMeta: 'Hier is de tekst van recente in-app-meldingen met betrekking tot app-updates, veiligheidsmededelingen, updates van gebruikershandleidingen',
    keywords: 'meldingen' ,
    localeMeta: 'nl_NL',

    heading: 'Recente in-app meldingen',
    subheading: '',

    header_133:'',
    body_133:'',

    header_132:'Android-app-update (YpsoPump only) 28/10/2026',
    body_132:'Beste CamAPS FX-gebruiker, een nieuwe versie van de applicatie 1.4(195) zal binnen enkele dagen beschikbaar zijn. Kies alstublieft uw gewenste update tijd door de automatische update voor CamAPS FX in de Google Play Store uit te schakelen. Als u vragen heeft, neem dan contact op met de klantenservice van mylife-Diabetescare.',

    header_131:'',
    body_131:'',

    header_130:'Update vereist (alleen YpsoPump) 20/10/2026',
    body_130:'Update vereist! Deze versie van CamAPS FX kan vaker vastlopen en opnieuw opstarten. Werk NU bij naar de nieuwste versie via de Google Play Store. Appversie 1.4(190) wordt op 20/11/2026 stopgezet. Na deze datum is “Auto Mode” niet langer beschikbaar totdat de app is bijgewerkt. De insulinetoediening via uw pomp gaat door.',

    header_129:'',
    body_129:'',

    header_128:'Update gebruikershandleiding (alleen YpsoPump) 15/10/2026',
    body_128:'Er is nu een bijgewerkte versie van de gebruikershandleiding beschikbaar. U kunt deze openen via het hoofdmenu van CamAPS FX door Help te selecteren nadat u hebt bijgewerkt naar de nieuwste appversie.',

    header_127:'iOS app-update (YpsoPump only) 08/10/2026',
    body_127:'Beste CamAPS FX-gebruiker, er zal binnenkort een NIEUWE VERSIE van de applicatie 1.4(196) beschikbaar zijn. DEACTIVEER CamAPS FX AUTOMATISCHE UPDATES in de App Store om uw voorkeursupdate-tijd te selecteren. Als u vragen heeft, neem dan contact op met de klantenservice van mylife-Diabetescare.',

    header_126:'Android-app-update (YpsoPump only) 02/10/2026',
    body_126:'Beste CamAPS FX-gebruiker, een nieuwe versie van de applicatie 1.4(194) zal binnen enkele dagen beschikbaar zijn. Kies alstublieft uw gewenste update tijd door de automatische update voor CamAPS FX in de Google Play Store uit te schakelen. Als u vragen heeft, neem dan contact op met de klantenservice van mylife-Diabetescare.',

    header_125:'',
    body_125:'',

    header_124:'',
    body_124:'',

    header_123:'',
    body_123:'',

    header_122:'',
    body_122:'',

    header_121:'Apple iOS 27 release 11/09/2026',
    body_121:'Apple zal binnenkort iOS 27 uitbrengen. Om een ononderbroken gebruik van de CamAPS FX-app te garanderen, controleer VOORDAT u uw iPhone naar iOS 27 bijwerkt op de website van de sensorfabrikant of uw smartphone en besturingssysteem compatibel zijn. Automatische updates kunnen standaard AAN staan in de instellingen van uw telefoon; overweeg deze UIT te schakelen.',

    header_120:'',
    body_120:'',

    header_119:'Update gebruikershandleiding (alleen YpsoPump) 10/09/2026',
    body_119:'Er is nu een bijgewerkte versie van de gebruikershandleiding beschikbaar. U kunt deze openen via het hoofdmenu van CamAPS FX door Help te selecteren nadat u hebt bijgewerkt naar de nieuwste appversie.',

    header_118:'Android-app-update (YpsoPump only) 07/09/2026',
    body_118:'Beste CamAPS FX-gebruiker, een nieuwe versie van de applicatie 1.4(193) zal binnen enkele dagen beschikbaar zijn. Kies alstublieft uw gewenste update tijd door de automatische update voor CamAPS FX in de Google Play Store uit te schakelen. Als u vragen heeft, neem dan contact op met de klantenservice van mylife-Diabetescare.',

    header_117:'',
    body_117:'',

    header_116:'',
    body_116:'',

    header_115:'',
    body_115:'',

    header_114:'',
    body_114:'',

    header_113:'',
    body_113:'',

    header_112:'',
    body_112:'',

    header_111:'Deactivatie van Android-versies lager dan 1.4(192) (Ypsopump only) 03/08/2026',
    body_111:'Beste CamAPS FX-gebruiker, om redenen van cyberbeveiliging worden versies LAGER DAN 1.4(192) stopgezet op 31/08/2026. Zorg ervoor dat uw app vóór deze datum is BIJGEWERKT naar versie 1.4(192). Als u vragen heeft, neem dan contact op met de klantenservice van mylife-Diabetescare.',

    header_110:'',
    body_110:'',
    body_110_link_text:'',
    body_110_end: '',
    body_110_link:'',

    header_109:'Android OS 17-release 24/06/2026',
    body_109:'Android zal binnenkort OS 17 uitbrengen. Om een ononderbroken gebruik van de CamAPS FX-app te garanderen, controleer VOORDAT u uw Android naar OS 17 bijwerkt op de website van de sensorfabrikant of uw smartphone en besturingssysteem compatibel zijn. Automatische updates kunnen standaard AAN staan in de instellingen van uw telefoon; schakel deze UIT.',

    header_108:'Dexcom G7 is beschikbaar (alleen Ypsopump) 23/06/2026',
    body_108:'De integratie van het Dexcom G7 CGM-systeem is nu beschikbaar! Gebruikers die overstappen van Dexcom G6 vinden op onze website een overstapgids, ondersteuning bij probleemoplossing en een overzicht van compatibele CGM-systemen: www.mylife-diabetescare.com.',

    header_107:'',
    body_107:'',

    header_106:'Update gebruikershandleiding (alleen YpsoPump) 22/06/2026',
    body_106:'Er is nu een bijgewerkte versie van de gebruikershandleiding beschikbaar. U kunt deze openen via het hoofdmenu van CamAPS FX door Help te selecteren.',

    header_105:'',
    body_105:'',

    header_104:'',
    body_104:'',

    header_103:'Android-app-update (YpsoPump only) 12/06/2026',
    body_103:'Beste mylife CamAPS FX-gebruiker, een nieuwe versie van de applicatie 1.4(192) zal binnen enkele dagen beschikbaar zijn. Kies alstublieft uw gewenste update tijd door de automatische update voor CamAPS FX in de Google Play Store uit te schakelen. Als u vragen heeft, neem dan contact op met de klantenservice van mylife-Diabetescare.',

    header_102:'',
    body_102:'',

    header_101:'',
    body_101:'',

    header_100:'',
    body_100:'',

    header_99:'',
    body_99:'',

    header_98:'Beëindiging van oude besturingssystemen 22/05/2026',
    body_98:'Terwijl we onze volgende app-update voorbereiden, dient u er rekening mee te houden dat CamAPS FX ALLEEN wordt ondersteund op sensorcompatibele telefoons met OS 13 of hoger of Apple iOS 18 of hoger. Na deze release kunnen gebruikers met telefoons met een versie ONDER OS 13 of iOS 18 CamAPS FX NIET meer BIJWERKEN of OPNIEUW INSTALLEREN.',

    header_97:'iOS app-update 22/05/2026',
    body_97:'Beste CamAPS FX-gebruiker, een nieuwe versie van CamAPS FX, 1.4(195), zal in de komende dagen beschikbaar zijn. Om zelf te kiezen wanneer u wilt updaten, schakelt u AUTOMATISCHE UPDATES uit in de App Store. Gebruikers met een versie ONDER Apple iOS 18 kunnen CamAPS FX NIET naar deze versie BIJWERKEN. Er is nu een bijgewerkte versie van de gebruikershandleiding beschikbaar. Neem bij vragen contact op met de klantenservice van mylife-Diabetescare.',

    header_96:'',
    body_96:'',

    header_95:'',
    body_95:'',

    header_94:'',
    body_94:'',

    header_93:'Deactivering van iOS-versies onder 1.4(193) (alleen Ypsopump) 22/04/2026',
    body_93:'Beste CamAPS FX-gebruiker, om redenen van cyberbeveiliging zullen VERSIES ONDER 1.4(193) op 30 april WORDEN GEDEACTIVEERD. Zorg ervoor dat uw app vóór deze datum is BIJGEWERKT naar versie 1.4(193). Neem bij vragen contact op met de mylife-Diabetescare klantenservice.',

    header_92:'Deactivering van eerdere besturingssystemen 21/04/2026',
    body_92:'Om redenen van cyberbeveiliging wordt mylife CamAPS FX vanaf 30 juni 2026 ALLEEN ondersteund op sensorcompatibele telefoons die de volgende besturingssystemen gebruiken: Android OS 13 en hoger en Apple iOS 18 en hoger. Gebruikers van besturingssystemen ONDER Android OS 13 of Apple iOS 18 kunnen mylife CamAPS FX na deze datum NIET meer BIJWERKEN of OPNIEUW INSTALLEREN.',

    header_91:'',
    body_91:'',
    body_91_link_text:'',
    body_91_end: '',
    body_91_link:'',

    header_90:'',
    body_90:'',

    header_89:'',
    body_89:'',

    header_88:'',
    body_88:'',

    header_87:'Deactivering van iOS-versies onder 1.4(193) (alleen Ypsopump) 16/03/2026',
    body_87:'Beste CamAPS FX-gebruiker, om redenen van cyberbeveiliging zullen VERSIES ONDER 1.4(193) op 31 maart WORDEN GEDEACTIVEERD. Zorg ervoor dat uw app vóór deze datum is BIJGEWERKT naar versie 1.4(193). Neem bij vragen contact op met de mylife-Diabetescare klantenservice.',

    header_86:'',
    body_86:'',
    body_86_link_text:'',
    body_86_end: '',
    body_86_link:'',

    header_85:'',
    body_85:'',

    header_84:'',
    body_84:'',

    header_83:'',
    body_83:'',

    header_82:'Android-app-update (alleen Ypsopump) 02/02/2026',
    body_82:'Beste CamAPS FX-gebruiker, in de komende dagen zal een NIEUWE VERSIE van de applicatie beschikbaar zijn – 1.4(190). DEACTIVEER AUTOMATISCHE UPDATES van CamAPS FX in de Google Play Store om zelf het gewenste update-moment te kiezen. Om redenen van cyberbeveiliging zullen VERSIES ONDER 1.4(190) op 31 maart WORDEN STOPGEZET. Neem bij vragen contact op met de mylife-Diabetescare klantenservice.',

    header_81:'',
    body_81:'',

    header_80:'',
    body_80:'',

    header_79:'',
    body_79:'',

    header_78:'',
    body_78:'',

    header_77:'Bericht van mylife-Diabetescare (alleen YpsoPump) 17/12/2025',
    body_77:'Alleen voor NL & BE - Vanaf vandaag vragen we u om uw mylife uw reservoir één keer te hervullen. Dit helpt om de therapie te continueren voor u én voor anderen. Dank u wel voor uw ondersteuning.',

    header_76:'',
    body_76:'',

    header_75:'',
    body_75:'',

    header_74:'Bericht van mylife-Diabetescare (alleen YpsoPump) 09/12/2025',
    body_74:'U kunt uw mylife YpsoPump-reservoir nu één keer hervullen binnen 7 dagen na de eerste vulling. Bekijk de instructies op de reservoir-pagina van de mylife-diabetescare-website.',

    header_73:'',
    body_73:'',
    body_73_link_text:'',
    body_73_end: '',
    body_73_link:'',

    header_72:'Belangrijke veiligheidsinformatie over uw FreeStyle Libre 3-systeemsensor (Alleen voor NL) 25/11/2025',
    body_72:'Abbott heeft vastgesteld dat sommige FreeStyle Libre 3- en FreeStyle Libre 3 Plus-sensoren mogelijk vals-lage glucosewaarden weergeven. Ga naar',
    body_72_link_text:'www.FreeStyleCheck.com',
    body_72_end: ' om te controleren of uw huidige of ongebruikte sensor(en) potentieel getroffen is/zijn. Als uw sensorwaarden niet overeenkomen met uw symptomen of verwachtingen, schakel de Auto-modus uit en gebruik een bloedglucosemeter om behandelbeslissingen te nemen. Als u vragen heeft of problemen met uw FreeStyle Libre 3-systeemsensor wilt melden, neem dan contact op met Abbott Klantenservice via 0800 022 88 28. Het serienummer van de huidige sensor staat vermeld in het menu van de applicatie onder Sensor.',
    body_72_link:'https://www.FreeStyleCheck.com',

    header_71:'Belangrijke veiligheidsinformatie over uw FreeStyle Libre 3-systeemsensor (Alleen voor LU) 25/11/2025',
    body_71:'Alleen voor LU - Abbott heeft vastgesteld dat sommige FreeStyle Libre 3- en FreeStyle Libre 3 Plus-sensoren mogelijk vals-lage glucosewaarden weergeven. Ga naar',
    body_71_link_text:'www.FreeStyleCheck.com',
    body_71_end: ' om te controleren of uw huidige of ongebruikte sensor(en) potentieel getroffen is/zijn. Als uw sensorwaarden niet overeenkomen met uw symptomen of verwachtingen, schakel de Auto-modus uit en gebruik een bloedglucosemeter om behandelbeslissingen te nemen. Als u vragen heeft of problemen met uw FreeStyle Libre 3-systeemsensor wilt melden, neem dan contact op met Abbott Klantenservice via 8002 54 87. Het serienummer van de huidige sensor staat vermeld in het menu van de applicatie onder Sensor.',
    body_71_link:'https://www.FreeStyleCheck.com',

    header_70:'Belangrijke veiligheidsinformatie over uw FreeStyle Libre 3-systeemsensor (Alleen voor BE) 25/11/2025',
    body_70:'Abbott heeft vastgesteld dat sommige FreeStyle Libre 3- en FreeStyle Libre 3 Plus-sensoren mogelijk vals-lage glucosewaarden weergeven. Ga naar www.FreeStyleCheck.com om te controleren of uw huidige of ongebruikte sensor(en) potentieel getroffen is/zijn. Als uw sensorwaarden niet overeenkomen met uw symptomen of verwachtingen, schakel de Auto-modus uit en gebruik een bloedglucosemeter om behandelbeslissingen te nemen. Als u vragen heeft of problemen met uw FreeStyle Libre 3-systeemsensor wilt melden, neem dan contact op met Abbott Klantenservice via 0800 167 72',
    body_70_link_text:'ADC',
    body_70_end: '. Het serienummer van de huidige sensor staat vermeld in het menu van de applicatie onder Sensor.',
    body_70_link:'https://www.FreeStyleCheck.com',
	
    header_69:'iOS app update (YpsoPump alleen) 25/11/2025',
    body_69:'Beste mylife CamAPS FX-gebruiker, een NIEUWE VERSIE van de applicatie zal binnen enkele dagen beschikbaar zijn. DEACTIVEEER CamAPS FX AUTOMATISCHE UPDATES in de App Store om uw voorkeurstijd voor updates te selecteren. Uw huidige versie wordt STOPGEZET op 9 december 2025. Als u vragen heeft, neem dan contact op met de klantenservice van Ypsomed.',
	
    header_68:'',
    body_68:'',
	
    header_67:'',
    body_67:'',

    header_66:'',
    body_66:'',
    body_66_link_text:'',
    body_66_end: '',
    body_66_link:'',

    header_65:'',
    body_65:'',
    body_65_link_text:'',
    body_65_end: '',
    body_65_link:'',

    header_64:'',
    body_64:'',
    body_64_link_text:'',
    body_64_end: '',
    body_64_link:'',

    header_63:'',
    body_63:'',
    body_63_link_text:'',
    body_63_end: '',
    body_63_link:'',

    header_62:'BERICHT INZAKE DE VEILIGHEID 28/10/2025',
    body_62:'Lees deze veiligheidsinformatie',
    body_62_link_text:'N-0125',
    body_62_end: '. Ga naar het app-menu -> Veiligheidsmeldingen.',
    body_62_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+Mylife+Users+NL+final.pdf',

    header_61:'iOS-appupdate (alleen YpsoPump) 02/10/2025',
    body_61:'Voor optimale app-prestaties, UPDATE uw mylife CamAPS FX naar DE LAATSTE VERSIE (1.4(192)) via de Apple App Store.',

    header_60:'',
    body_60:'',

    header_59:'iOS app-update (YpsoPump alleen) 22/09/2025',
    body_59:'Beste mylife CamAPS FX-gebruiker, er zal binnenkort een NIEUWE VERSIE van de applicatie beschikbaar zijn. DEACTIVEER CamAPS FX AUTOMATISCHE UPDATES in de App Store om uw voorkeursupdate-tijd te selecteren. Een nieuwe versie van de gebruikershandleiding zal beschikbaar zijn. Als u vragen heeft, neem dan contact op met de klantenservice van Ypsomed.',

    header_58:'iOS 26 release (YpsoPump alleen) 13/09/2025',
    body_58:'Apple zal binnenkort iOS 26 uitbrengen. Om ononderbroken gebruik van de mylife CamAPS FX-applicatie te waarborgen, controleer alstublieft de website van de sensorfabrikant om de compatibiliteit van uw smartphone en besturingssysteem te verifiëren voordat u uw iPhone bijwerkt naar iOS 26. Opmerking: Automatische updates zijn mogelijk standaard ingeschakeld in de instellingen van uw telefoon, schakel deze alstublieft uit.',

    header_57:'Android-app-update (YpsoPump alleen) 26/08/2025',
    body_57:'Beste mylife CamAPS FX-gebruiker, een nieuwe versie van de applicatie zal binnen 2 tot 3 dagen beschikbaar zijn. Kies alstublieft uw gewenste update tijd door de automatische update voor CamAPS FX in de Google Play Store uit te schakelen. Een nieuwe versie van de gebruikershandleiding zal beschikbaar zijn. Als u vragen heeft, neem dan contact op met de klantenservice van Ypsomed.',

    header_56:'',
    body_56:'',

    header_55:'',
    body_55:'',

    header_54:'',
    body_54:'',

    header_53:'',
    body_53:'',
	
    header_52:'',
    body_52:'',
	
    header_51:'',
    body_51:'',

    header_50:'',
    body_50:'',

    header_49:'Beëindiging van oude appversies 01/07/2025',
    body_49:'De huidige versie eindigt op 1 augustus 2025. Update je app naar de nieuwste versie die beschikbaar is op Google Play.',

    header_48:'OS 10 & 11 25/06/2025',
    body_48:'Per 1 Augustus 2025 worden alleen nog smartphones ondersteund die compatible zijn met besturingssysteem (OS) 12 of hoger en uw CGM sensor. Als uw smartphone niet geschikt is voor een update naar OS12 of hoger, zal u tegen die tijd over moeten stappen op een andere smartphone. OS10 en OS11 zijn verouderd en worden door Android niet langer technisch ondersteund en krijgen ook geen veiligheid updates meer.',

    header_47:'iOS-versie (alleen YpsoPump) 09/06/2025',
    body_47:'De mylife CamAPS FX-app is nu ook beschikbaar voor iPhones! Let op: nog niet alle functies zijn beschikbaar in de iOS versie. Raadpleeg daarom voordat u overstapt: \'Belangrijke informatie voor iOS-gebruikers\' op https://www.mylife-diabetescare.com/nl-NL/mylife-loop.html.',

    header_46:'',
    body_46:'',

    header_45:'Android OS 16 09/06/2025',
    body_45:'Waarschuwing: Werk uw smartphone niet bij naar Android OS16 zonder eerst de compatibiliteit te controleren op de website van de fabrikant van de sensor. Gebrekkige compatibiliteit kan de functionaliteit van de mylife CamAPS FX-app beïnvloeden. Houd er rekening mee dat automatische updates mogelijk standaard zijn ingeschakeld in de instellingen van je telefoon.',

    header_44:'Gebruikershandleiding bijwerken 20/05/2025',
    body_44:'Er is een bijgewerkte versie van de gebruikershandleiding beschikbaar.',

    header_43:'',
    body_43:'',

    header_42:'',
    body_42:'',
	
    header_41:'',
    body_41:'',

    header_40:'Nieuwe update (18/03/2025)',
    body_40:'Geachte mylife CamAPS FX-gebruiker, Binnen de komende 48 uur zal een nieuwe app-versie beschikbaar zijn. Om uw voorkeurstijd voor de update te kiezen, schakelt u de automatische updates voor CamAPS FX uit in de Google Play Store. Als u vragen heeft, neem dan contact op met de klantenservice van Ypsomed.',

    header_39:'',
    body_39:'',

    header_38:'',
    body_38:'',

    header_37:'Stopzetting van de oude app-versie (alleen Ypsopump)',
    body_37:'De huidige versie eindigt op 7 februari 2025. Update je app naar de nieuwste versie die beschikbaar is op Google Play.',

    header_36:'een nieuwe app-versie beschikbaar 06/01/2025',
    body_36:'Geachte mylife CamAPS FX-gebruiker, Binnen de komende 24 uur zal een nieuwe app-versie beschikbaar zijn. Om uw voorkeurstijd voor de update te kiezen, schakelt u de automatische updates voor CamAPS FX uit in de Google Play Store. Als u vragen heeft, neem dan contact op met de klantenservice van Ypsomed.',
	
	header_35:'OS 8 & 9 29/12/2024',
    body_35:'Per 1 januari 2025 worden alleen nog smartphones ondersteund die compatible zijn met besturingssysteem (OS) 10 of hoger en uw CGM sensor. Als uw smartphone niet geschikt is voor een update naar OS10 of hoger, zal u tegen die tijd over moeten stappen op een andere smartphone. OS8 en OS9 zijn verouderd en worden door Android niet langer technisch ondersteund en krijgen ook geen veiligheid updates meer. Herinnering, het systeem is nog niet compatibel met OS15.',
	
	header_34:'',
    body_34:'',
	
	header_33:'Kennisgeving van gepland onderhoud 05/12/2024',
    body_33:'Vanwege geplande onderhoudswerkzaamheden aan de CamAPS FX Service cloud, zal de Companion-functionaliteit op 7 december vanaf 10:00 GMT ongeveer drie uur niet beschikbaar zijn. Onze excuses voor het ongemak dat dit kan veroorzaken.',
	
	header_32:'Gebruikershandleiding bijwerken 28/11/2024',
    body_32:'Er is een bijgewerkte versie van de gebruikershandleiding beschikbaar.',
	
	header_31:'een nieuwe app-versie beschikbaar 17/11/2024',
    body_31:'Geachte mylife CamAPS FX-gebruiker, Binnen de komende 24 uur zal een nieuwe app-versie beschikbaar zijn. Om uw voorkeurstijd voor de update te kiezen, schakelt u de automatische updates voor CamAPS FX uit in de Google Play Store. Als u vragen heeft, neem dan contact op met de klantenservice van Ypsomed.',
	
	header_30:'OS 8 & 9 11/10/2024',
    body_30:'Per 1 januari 2025 worden alleen nog smartphones ondersteund die compatible zijn met besturingssysteem (OS) 10 of hoger en uw CGM sensor. Als uw smartphone niet geschikt is voor een update naar OS10 of hoger, zal u tegen die tijd over moeten stappen op een andere smartphone. OS8 en OS9 zijn verouderd en worden door Android niet langer technisch ondersteund en krijgen ook geen veiligheid updates meer.',
	
	header_29:'een nieuwe app-versie beschikbaar 09/10/2024',
    body_29:'Geachte mylife CamAPS FX-gebruiker, Binnen de komende 24 uur zal een nieuwe app-versie beschikbaar zijn. Om uw voorkeurstijd voor de update te kiezen, schakelt u de automatische updates voor CamAPS FX uit in de Google Play Store. Als u vragen heeft, neem dan contact op met de klantenservice van Ypsomed.',
	
	header_28:'OS 8 & 9 08/07/2024',
    body_28:'Per 1 januari 2025 worden alleen nog smartphones ondersteund die compatible zijn met besturingssysteem (OS) 10 of hoger en uw CGM sensor. Als uw smartphone niet geschikt is voor een update naar OS10 of hoger, zal u tegen die tijd over moeten stappen op een andere smartphone. OS8 en OS9 zijn verouderd en worden door Android niet langer technisch ondersteund en krijgen ook geen veiligheid updates meer.',
	
	header_27:'',
    body_27:'',
	
	header_26:'Gebruikershandleiding bijwerken 11/05/2024',
    body_26:'Er is een bijgewerkte versie van de gebruikershandleiding beschikbaar.',
	
	header_25:'',
    body_25:'',
	
	header_24:'',
    body_24:'',
	
	header_23:'een nieuwe app-versie beschikbaar 24/04/2024',
    body_23:'Geachte mylife CamAPS FX-gebruiker, Binnen de komende 24 uur zal een nieuwe app-versie beschikbaar zijn. Om uw voorkeurstijd voor de update te kiezen, schakelt u de automatische updates voor CamAPS FX uit in de Google Play Store. Als u vragen heeft, neem dan contact op met de klantenservice van Ypsomed.',
	
	header_22:'Gebruikershandleiding bijwerken 21/04/2024',
    body_22:'Er is een bijgewerkte versie van de gebruikershandleiding beschikbaar.',
	
	header_21:'',
    body_21:'',
	
	header_20:'',
    body_20:'',
	
	header_19:'',
    body_19:'',

    header_18:'',
    body_18:'',

    header_17:'',
    body_17:'',

	header_16:'Gebruikershandleiding bijwerken 04/03/2024',
    body_16:'Er is een bijgewerkte versie van de gebruikershandleiding beschikbaar.',
	
	header_15:'Gebruikershandleiding bijwerken 04/01/2024',
    body_15:'Er is een bijgewerkte versie van de gebruikershandleiding beschikbaar.',
	
	header_14:'Android OS 14. 22/11/2023',
    body_14:'Herinnering: Let op: update uw smartphone niet naar Android OS14 zonder eerst de compatibiliteit op de website van de fabrikant van de sensor te controleren. Het niet compatibel zijn, kan van invloed zijn op functioneren van de mylife CamAPS FX app. Let op dat automatische updates standaard ingeschakeld kunnen zijn in de instellingen van uw telefoon.',
	
	header_13:'BERICHT INZAKE DE VEILIGHEID 14/11/2023',
    body_13:'BERICHT INZAKE DE VEILIGHEID ',
    body_13_link_text:'Lees deze veiligheidsinformatie',
    body_13_end: '. Ga naar het app-menu -> Veiligheidsmeldingen.',
    body_13_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET5604+Mylife+Users+final+-+NL.pdf',

	header_12:'Gebruikershandleiding bijwerken 10/11/2023',
    body_12:'Er is een bijgewerkte versie van de gebruikershandleiding beschikbaar.',
	
	header_11:'Android OS 14. 13/09/2023',
    body_11:'Let op: update uw smartphone niet naar Android OS14 zonder eerst de compatibiliteit op de website van de fabrikant van de sensor te controleren. Het niet compatibel zijn, kan van invloed zijn op functioneren van de mylife CamAPS FX app. Let op dat automatische updates standaard ingeschakeld kunnen zijn in de instellingen van uw telefoon.Zorg ervoor dat u mylife CamAPS FX-app versie 1.4(173) gebruikt voordat u bijwerkt naar Android OS 14.',
	
	header_10:'BERICHT INZAKE DE VEILIGHEID 15/08/2023',
    body_10:'BERICHT INZAKE DE VEILIGHEID Lees deze veiligheidsinformatie. Ga naar het app-menu -> Veiligheidsmeldingen.',
	
	header_9:'Gebruikershandleiding bijwerken 27/07/2023',
    body_9:'Er is een bijgewerkte versie van de gebruikershandleiding beschikbaar.',
	
	header_8:'Glooko-Kompatibilität 21/07/2023)',
    body_8:'Zoals eerder aangekondigd stopt Diasend per 28 juli. Als u uw gegevens wilt blijven delen met uw diabetesteam, kunt u uw Diasend-account upgraden naar Glooko of een nieuw Glooko-account aanmaken. Werk bij naar de nieuwste mylife CamAPS FX-versie, voer uw nieuwe Glooko-gebruikersnaam en wachtwoord in in het share-menu en start uw smartphone opnieuw op. Diasend blijft beschikbaar voor het bekijken van historische gegevens voor de rest van het jaar.',
	
	header_7:'Samsung smartphones uit de A-serie 14/07/2023',
    body_7:'Gebruikers van Samsung smartphones uit de A-serie (bijv. A53, A33) hebben mogelijk signaalverlies ondervonden met de CGM-sensor na de recente Samsung One UI 5.1-update. Samsung heeft het probleem geïdentificeerd en er wordt momenteel aan een oplossing gewerkt. Samsung is van plan een update voor One UI uit te brengen op 24 juli (afhankelijk van je regio), die het probleem van signaalverlies zal oplossen. Het wordt aanbevolen om de update te installeren zodra deze beschikbaar is. Als je nog niet hebt bijgewerkt naar One UI 5.1, raden we aan te wachten op de volgende Samsung One UI-update.',

    header_6:'Glooko-Kompatibilität (Alleen Ypsomed) 29/06/2023',
    body_6:'mylife CamAPS FX is compatibel met Glooko. Update alstublieft uw mylife CamAPS FX-app naar versie 1.4(172). Als u gegevens deelt met een kliniek, wordt u op de hoogte gesteld via uw bestaande diasend-account wanneer uw kliniek overstapt naar Glooko. Zodra de upgrade is voltooid, voert u uw nieuwe Glooko gebruikersnaam en wachtwoord in het deelmenu in en herstart u uw smartphone. Upgrade alstublieft naar Glooko vóór 28 juli 2023. Diasend blijft beschikbaar om historische gegevens te bekijken gedurende de rest van het jaar.',

    header_5:'',
    body_5:'',

    header_4:'Gebruikershandleiding bijwerken 27/05/2023',
    body_4:'Er is een bijgewerkte versie van de gebruikershandleiding beschikbaar.',

    header_3:'SMS-waarschuwingen (Alleen Ypsopump) 11/05/2023',
    body_3:'Met de aanstaande update 1.4(171) medio mei, kunt u tot 5 actieve SMS-volgers aanmaken en tegelijkertijd de Companion-modus gebruiken. Om de Companion-modus te gebruiken, moet de telefoon van de gebruiker een internetverbinding hebben om gegevens te delen. Gebruikers moeten een SIM-kaart hebben om SMS-berichten vanaf hun telefoon te kunnen verzenden. Als u van een of beide opties gebruik wenst te maken, raden wij u aan om te controleren of uw mobiele bundel (voldoende) voldoet.',

    header_2:'Cyberbeveiligingsupdate (Alleen Ypsopump) 24/04/2023',
    body_2:'Het veilige gebruik van medische apps zoals de mylife CamAPS FX app is essentieel. Daarom voert Google Play Store medio mei een verplichte cybersecurity update door. Wij adviseren u om vooraf te checken of uw smartphone voldoet aan de nieuwe veiligheidseisen, zodat u de mylife CamAPS app na invoering kunt blijven gebruiken. Open het menu in de mylife CamAPS app, ga naar ‘help’ en check uw toestel voor medio mei.',

    header_1:'',
    body_1:'',
};
